export function TitleAttractScene() {
  return (
    <main className="attract-scene title-attract" aria-labelledby="title-attract-heading">
      <div className="title-attract__city" aria-hidden="true" />
      <div className="title-attract__impact" aria-hidden="true" />
      <div className="title-attract__lockup">
        <p>L34D SOFTWARE PRESENTS</p>
        <img src="/assets/references/logo_game.png" alt="" width="981" height="369" />
        <h1 id="title-attract-heading">Island Beatdown</h1>
        <strong>THE FIGHTING TOURNAMENT</strong>
      </div>
      <div className="title-attract__board"><span>SMK-94 ARCADE SYSTEM</span><span>30 FIGHTERS</span><span>© L34D SOFTWARE</span></div>
    </main>
  );
}
